import ToolingLocationsSearchGrid from './ToolingLocationsSearchGrid';

export default ToolingLocationsSearchGrid;



// WEBPACK FOOTER //
// ./src/components/grids/ToolingLocationsSearchGrid/index.jsx